import { render, staticRenderFns } from "./lrTag.vue?vue&type=template&id=ab720e92"
import script from "./lrTag.vue?vue&type=script&lang=js"
export * from "./lrTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports